export const closeIcon = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.9231 0L14 1.07692L8.076 7L14 12.9231L12.9231 14L7 8.076L1.07692 14L0 12.9231L5.924 7L0 1.07692L1.07692 0L7 5.924L12.9231 0Z" fill="#191919"/>
</svg>
`;
